import { useRef } from 'react';

export const useScrollBottom = () => {
  const scrollElementRef = useRef();

  const scrollToBottom = (scrollHeight) => {
    setTimeout(() => {
      scrollElementRef.current.scrollTop =
        scrollHeight ?? scrollElementRef.current.scrollHeight;
    }, 0);
  };
  return [scrollElementRef, scrollToBottom];
};
